export const trans_2_2=[
    {
      id:1,
      english:'Where do you come from? I come from Malaysia',
      vietnamese:'Bạn đến từ đâu? Tôi đến từ Malaysia',
      user_message:''
    },
    {
      id:2,
      english:'Who is that? that is Natasha, she comes from Russia',
      vietnamese:'Kia là ai? Kia là Natasha, cô ấy đến từ Nga',
      user_message:''
    },
    {
      id:3,
      english:' Mr. George! This is my mother that is my father',
      vietnamese:'Tựa thầy George! Đây là mẹ của em, kia là bố của em',
      user_message:''
    },
    {
      id:4,
      english:'Thank you! Nice to meet you',
      vietnamese:'Cảm ơn em! Rất hân hạnh được gặp em',
      user_message:''
    }
    ,
    {
      id:5,
      english:'Hello Ms. Lan. Long time not see. How are you?',
      vietnamese:'Chào cô Lan. Lâu rồi không gặp cô. Cô có khỏe không?',
      user_message:''
    },
    {
      id:6,
      english:' My brother is not very good',
      vietnamese:'Em trai của tôi không được khỏe lắm',
      user_message:''
    },
    {
        id:7,
        english:'My teachers name Matthew. He is American',
        vietnamese:'Thầy giáo của tôi tên l Matthew. Thầy là người Mỹ',
        user_message:''
    },
    {
      id:8,
      english:'This is my Vietnamese book',
      vietnamese:'Đây là quyển sách tiếng Việt của tôi',
      user_message:''
    },
    {
      id:9,
      english:'How is your mother? thank you! She is headache recently',
      vietnamese:'Mê của bạn có khỏe không? Cảm ơn! Dạo này bà ấy bị đau đầu',
      user_message:''
    },
    {
      id:10,
      english:'What is that?  That is my pen. Thank you!',
      vietnamese:'Kia là cái gì? Đó là chiếc bút của tôi. Cảm ơn!',
      user_message:''
    },

  ]